import { getCoords, getDragItemCoords, getEventData, isInRange, isInRect, passThreshold, } from "../dnd";
import { locate, locateID } from "@xbs/lib-dom";
import { elementsIds } from "../constants";
export function dndAction(node, config) {
    if (config.readonly) {
        return;
    }
    let clone;
    let handlers;
    const kanbanElement = node;
    let kanbanContent;
    let scrollTimer;
    let dragCoords;
    let pointerDownData;
    let dragItemsCoords;
    let dropAreaItemsCoords;
    let dropAreasCoords;
    const dispatch = (name, data) => {
        config.api.exec(name, data);
        if (config.onAction) {
            config.onAction(name, data);
        }
    };
    const scrollableContent = node.querySelector(`[data-kanban-id='${elementsIds.scrollableContent}']`);
    scrollableContent?.addEventListener("scroll", () => {
        if (pointerDownData) {
            const { itemId, itemRect, itemsId } = pointerDownData;
            pointerDownData.scroll = {
                x: kanbanContent.scrollLeft,
                y: kanbanContent.scrollTop,
            };
            const coords = getCoords(kanbanElement, itemsId, true);
            dragItemsCoords = coords.dragItemsCoords;
            dropAreasCoords = coords.dropAreasCoords;
            dropAreaItemsCoords = coords.dropAreaItemsCoords;
            dragItemsCoords[itemId] = itemRect;
            dispatch("before-drag", {
                dragItemsCoords,
                dropAreasCoords,
            });
        }
    }, { capture: true });
    const { data: dataStore } = config.api.getStores();
    function checkScroll(e) {
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
        if (kanbanContent) {
            const contentRect = kanbanContent.getBoundingClientRect();
            const scrollState = {
                x: kanbanContent.scrollLeft,
                y: kanbanContent.scrollTop,
            };
            const shift = 50;
            if (e.clientX > contentRect.width + contentRect.left - shift) {
                kanbanContent.scrollTo(scrollState.x + shift, scrollState.y);
            }
            if (e.clientX < contentRect.left + shift) {
                kanbanContent.scrollTo(scrollState.x - shift, scrollState.y);
            }
            if (e.clientY > contentRect.height + contentRect.top - shift) {
                kanbanContent.scrollTo(scrollState.x, scrollState.y + shift);
            }
            if (e.clientY < contentRect.top + shift) {
                kanbanContent.scrollTo(scrollState.x, scrollState.y - shift);
            }
            scrollTimer = setTimeout(() => {
                checkScroll(e);
            }, 100);
        }
    }
    function getOverItems(relativeCoords) {
        const items = {};
        const areaId = dropAreasCoords.find(col => {
            return isInRect(relativeCoords, col);
        })?.id;
        if (areaId) {
            items.overAreaId = areaId;
        }
        if (areaId) {
            const dragItems = dropAreaItemsCoords[areaId];
            items.before = dragItems.find(d => {
                return isInRange(relativeCoords.y, [d.y, d.bottom]);
            })?.id;
        }
        return items;
    }
    function startDrag(ev, pointerCoords, relativeCoords, pointerDownData, selected) {
        if (ev.touches && ev.touches.length > 1) {
            return;
        }
        dispatch("before-drag", {
            dragItemsCoords,
            dropAreasCoords,
        });
        if (selected?.indexOf(pointerDownData.itemId) === -1) {
            dispatch("select-card", {
                id: pointerDownData.itemId,
                groupMode: true,
            });
            selected.push(pointerDownData.itemId);
        }
        const dragItemId = pointerDownData.itemId;
        const cardOriginCoords = dragItemsCoords[dragItemId];
        dragCoords = getDragItemCoords(pointerCoords, pointerDownData, cardOriginCoords);
        setDragItemClone(selected);
        const overItems = getOverItems(relativeCoords);
        dispatch("start-drag", { dragItemId, ...overItems });
    }
    function moveDragItem(state, pointerCoords, relativeCoords, pointerDownData) {
        const { overAreaId, before } = state;
        const dragItemCoords = dragItemsCoords[pointerDownData.itemId];
        dragCoords = getDragItemCoords(pointerCoords, pointerDownData, dragItemCoords);
        clone.style.left = dragCoords.x + "px";
        clone.style.top = dragCoords.y + "px";
        const overItems = getOverItems(relativeCoords);
        const nextState = {
            overAreaId,
            before,
        };
        if (overAreaId !== overItems.overAreaId) {
            nextState.overAreaId = overItems.overAreaId;
        }
        if (before !== overItems.before) {
            nextState.before = overItems.before;
        }
        dispatch("drag", nextState);
    }
    function setDragItemClone(selected) {
        const portal = document.querySelector(".wx-portal");
        if (selected && selected.length > 1) {
            portal.style.setProperty("--wx-kanban-dragged-cards-count", 
            // used to set variable value as string
            JSON.stringify(`${selected.length}`));
        }
        portal.appendChild(clone);
        clone.classList.add("wx-dragged-card");
        clone.style.position = "fixed";
        clone.style.left = dragCoords.x + "px";
        clone.style.top = dragCoords.y + "px";
        document.body.classList.add("wx-ondrag");
    }
    function removeDragItemClone() {
        if (clone.parentNode) {
            const portal = document.querySelector(".wx-portal");
            portal.removeChild(clone);
        }
        document.body.classList.remove("wx-ondrag");
        const portal = document.querySelector(".wx-portal");
        portal.style.removeProperty("--wx-kanban-dragged-cards-count");
        clone = null;
    }
    function getPointerRelativeCoords(e, kanbanContent, pointerDownData) {
        const initialScroll = pointerDownData.scroll;
        const contentScroll = {
            x: kanbanContent.scrollLeft,
            y: kanbanContent.scrollTop,
        };
        const relativeCoords = {
            x: e.clientX + (contentScroll.x - initialScroll.x),
            y: e.clientY + (contentScroll.y - initialScroll.y),
        };
        return relativeCoords;
    }
    function downHandler(e) {
        const ev = getEventData(e);
        if ((ev.touches && ev.touches.length > 1) ||
            ("button" in e && e.button !== 0)) {
            return;
        }
        const source = locate(ev.target, "data-drag-item");
        kanbanContent = kanbanElement.querySelector(`[data-kanban-id="${elementsIds.content}"]`);
        if (source) {
            const itemId = locateID(source, "data-drag-item");
            const areaId = locateID(ev.target, "data-drag-item");
            const selected = dataStore.getState().selected;
            const itemsId = selected && selected.length > 1
                ? [...selected, itemId]
                : [itemId];
            const coords = getCoords(kanbanElement, itemsId);
            dragItemsCoords = coords.dragItemsCoords;
            dropAreasCoords = coords.dropAreasCoords;
            dropAreaItemsCoords = coords.dropAreaItemsCoords;
            clone = source.cloneNode(true);
            handlers =
                "touches" in e
                    ? { up: "touchend", move: "touchmove" }
                    : { up: "mouseup", move: "mousemove" };
            document.addEventListener(handlers.move, moveHandler);
            document.addEventListener(handlers.up, upHandler);
            pointerDownData = {
                x: ev.clientX,
                y: ev.clientY,
                itemId,
                itemsId,
                itemRect: dragItemsCoords[itemId],
                areaId,
                scroll: {
                    x: kanbanContent.scrollLeft,
                    y: kanbanContent.scrollTop,
                },
            };
        }
    }
    function moveHandler(e) {
        e.preventDefault();
        e.stopPropagation();
        const ev = getEventData(e);
        checkScroll(ev);
        if (!pointerDownData) {
            return;
        }
        const state = dataStore.getState();
        const { selected, dragItemId } = state;
        const relativeCoords = getPointerRelativeCoords(ev, kanbanContent, pointerDownData);
        const pointerCoords = { x: ev.clientX, y: ev.clientY };
        if (!dragItemId && passThreshold(pointerDownData, pointerCoords)) {
            startDrag(ev, pointerCoords, relativeCoords, pointerDownData, selected);
        }
        if (dragItemId) {
            moveDragItem(state, pointerCoords, relativeCoords, pointerDownData);
        }
    }
    function upHandler() {
        document.removeEventListener(handlers.move, moveHandler);
        document.removeEventListener(handlers.up, upHandler);
        removeDragItemClone();
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
        const { dragItemId } = dataStore.getState();
        if (dragItemId) {
            dispatch("end-drag", null);
        }
        pointerDownData = null;
    }
    kanbanElement.addEventListener("mousedown", downHandler);
    kanbanElement.addEventListener("touchstart", downHandler);
    return {
        destroy() {
            kanbanElement.removeEventListener("mousedown", downHandler);
            kanbanElement.removeEventListener("touchstart", downHandler);
        },
    };
}
//# sourceMappingURL=drag.js.map